import React from 'react';
import { swatchStyle } from '../data/sauledaColours';
import './ColourSwatchGrid.css';

// Responsive grid of fabric swatches. Shared by the full /colours page and the
// compact grid on awning product pages, so the two can never drift apart.
//
// Appearance comes from swatchStyle() in data/sauledaColours.js - a weave
// photo for solids, vector stripes for stripes, the flat hex as the fallback.
export default function ColourSwatchGrid({ colours, onSelect, compact = false, stockCode }) {
  if (!colours || colours.length === 0) return null;

  return (
    <ul className={`csg${compact ? ' csg--compact' : ''}`}>
      {colours.map((c) => {
        const isStock = stockCode && c.code === stockCode;
        return (
          <li key={c.code} className="csg-item">
            <button
              type="button"
              className="csg-swatch"
              onClick={() => onSelect && onSelect(c)}
              aria-label={`${c.name}, Sauleda code ${c.code}${isStock ? ', held in stock' : ''}`}
            >
              <span
                className={`csg-chip${c.stripes ? ' csg-chip--stripe' : ''}`}
                style={swatchStyle(c, { repeatPx: 56 })}
              >
                {isStock && <span className="csg-stock-dot" aria-hidden="true" />}
              </span>
              <span className="csg-name">{c.name}</span>
              <span className="csg-code">{c.code}</span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
